import React from 'react'
import ClientAnalytics from '../../client/ClientAnalytics'
import V3AnalyticsRouteShell from '../analytics/V3AnalyticsRouteShell'

export default function V3ClientAnalyticsPage() {
  return (
    <V3AnalyticsRouteShell>
      {React.createElement(ClientAnalytics as any, { visualVariant: 'v3' })}
    </V3AnalyticsRouteShell>
  )
}

